export enum EPlacementVariants {
  Right = 'right',
  Left = 'left',
  Top = 'top',
  Bottom = 'bottom',
}

export enum ESizes {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum ELanguage {
  en = 'en',
  ru = 'ru',
}

export enum EAuth {
  TwoFA = '2fa',
  Login = 'login',
  Register = 'register',
  ResetPassword = 'resetPassword',
  ForgotPassword = 'forgotPassword',
}
